import './step.scss';
import './hireConfirmation.scss'

// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import { GDPRSignaturePattern } from 'components/gdprSignaturePattern/gdprSignaturePattern';
import {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} from 'components/contactCenter/confirmScript/confirmationScript';
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
//@commons
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents.js';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { OKLink } from 'commonsComponents/OKLink';

// @actions
import { setWizardButtonStateByButton } from 'actions/okWizard';

// @utils
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
const { recordGdprClauseInteraction } = require('utilities/consentsHelper');
const get = require('lodash/object/get');
const { buildNotDeductMessageNGO } = require('utilities/NGOHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { analyticsId, catalogue } = require('../analytics/hireSolidarityCardAnalytics');

// @constants
import {
    LIMIT_CHARITY_AMOUNT,
    SOLIDARITY_CARD_STANDARD,
    SOLIDARITY_CARD_SUBTYPE,
    SOLIDARITY_CARD_TYPE,
} from 'constants/index';
import {
    ADD_NEW_SHIPPING_ADDRESS,
    CHARITY_CARD_HIRE,
    messages,
    MULTIPLE_OPERATIONS,
    SOLIDARIA_CARD
} from 'constants/operationTypes';
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { SOLIDARITY_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
// contact center
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const { OPEN_DEBIT_GDPR_PID } = require('constants/gdprPlacementIds');

const {
    PROC_GDPR_CONSENTS_CONTRACTS,
    recordPage,
    recordLink,
} = require('utilities/tagging');

const { HIRE_CHARITY_GDPR, HIRE_CHARITY_NO_GDPR } = messages;

class HireConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authorization: __CONTACT_CENTER__,
            disclaimerErrorState: false,
            preContractURL: '',
            preContractURLError: false,
            showOTP: false,
        }
    }

    componentWillMount() {
        const isDeductible = this.props.charityFoundations.toJS().filter(foundation => foundation.suggestion.showNotDeductibleMessage === true);
        this.props.localSetWizardButtonStateByButton('submit', {
            loading: false,
            disabled: isDeductible
        });
    }

    componentDidMount() {
        const {
            onSetAsCurrentStep,
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
            processDetail,
        } = this.props;

        onSetAsCurrentStep(this.validate);
        recordPage(catalogue[analyticsId.SOLIDARITY_CARD_STEP_5_VIEW]({ productName: processDetail }));

        const precontractualMailProductInfo = {
            productName: SOLIDARITY_CARD_PRODUCT_NAME,
            producto: SOLIDARITY_CARD_TYPE,
            standard: SOLIDARITY_CARD_STANDARD,
            subproducto: SOLIDARITY_CARD_SUBTYPE
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__ && !!setTermsAndCondsText) {
            const termsAndConsText = [
                formatText('broker-stocksContractTACText1'),
                formatText('broker-stocksContractTACText2'),
                formatText('broker-stocksContractTACText3'),
                formatText('broker-stocksContractTACText4'),
                formatText('broker-stocksContractTACText5'),
            ];

            setTermsAndCondsText(termsAndConsText.join(' '));
        }
    }

    componentWillReceiveProps(nextProps) {
        const isDeductible = this.props.charityFoundations.toJS().filter(foundation => foundation.suggestion.showNotDeductibleMessage === true);

        if (isDeductible.length !== 0) {
            if (this.state.showOTP) {
                this.disabledButton(nextProps);
            }
        } else {
            this.disabledButton(nextProps);
        }
    }

    disabledButton = (nextProps) => {
        if (isPrintOfficeMode() && nextProps.immPrinter.get('documentsPrintedAndSigned') !== 'YES') {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: false,
                disabled: false
            });
        } else if (isPrintOfficeMode() && nextProps.immPrinter.get('documentsPrintedAndSigned') === 'YES') {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: nextProps.signaturePass.get('callbackCalled'),
                disabled: false
            });
        } else if (nextProps.signaturePass.get('requiredDigits') !== null) {
            if (nextProps.signaturePass.get('requiredDigits').size > 0) {
                this.props.localSetWizardButtonStateByButton('submit', {
                    loading: nextProps.signaturePass.get('callbackCalled'),
                    disabled: __CONTACT_CENTER__ ? false : !nextProps.signaturePass.get('isFetchingSignaturePassCodeSuccess')
                });
            } else {
                this.props.localSetWizardButtonStateByButton('submit', {
                    loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                    disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
                });
            }
        } else {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
            });
        }
        if (nextProps.signaturePass.get('isFetchingSignaturePassCodeSuccess') && nextProps.signaturePass.get('showWarningSMS')) {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: nextProps.signaturePass.get('isFetchingSMSCode'),
                disabled: !nextProps.signaturePass.get('isFetchingConfigSuccess')
            });
        }
    }

    validate = () => {
        if (__CONTACT_CENTER__) return { isValid: true }

        const { authorization } = this.state;

        if (authorization) {
            return {
                isValid: true,
                authorization
            };
        }

        this.setState({
            disclaimerErrorState: true
        })

        return {
            isValid: false
        };
    }

    handleOnChange = () => {
        this.setState({
            authorization: !this.state.authorization,
            disclaimerErrorState: false
        });
    }

    buildLegalConsentLabel() {
        return (
            <span className="stocks-contract-tac__text">
                <FormattedText value="broker-stocksContractTACText1" />
                &nbsp;
                <OKLink
                    to={formatText('broker-stocksContractTACText2Link')}
                    target="_blank"
                    modifier="emphasize"
                >
                    <FormattedText value="broker-stocksContractTACText2" />
                </OKLink>
                &nbsp;
                <FormattedText value="broker-stocksContractTACText3" />
                &nbsp;
                <OKLink
                    to={formatText('broker-stocksContractTACText4Link')}
                    target="_blank"
                    modifier="emphasize"
                >
                    <FormattedText value="broker-stocksContractTACText4" />
                </OKLink>
                {/* &nbsp; */} {/* Don't use spaces in POEditor!!! */}
                <FormattedText value="broker-stocksContractTACText5" />
            </span>
        );
    }

    onGdprAcceptAll(value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS)
    }

    onGdprChangeValue(id, value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const linkElement = event.target;
        if (linkElement) {
            recordLink(PROC_GDPR_CONSENTS_CONTRACTS, get(linkElement, 'attributes.data-title.value', ''));
        }
    }

    buildConsents() {
        return (
            <OKConsents
                placementId={OPEN_DEBIT_GDPR_PID}
                handleAcceptAll={this.onGdprAcceptAll}
                handleChangeValue={this.onGdprChangeValue}
                handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
            />
        )
    }

    handleChangeDeduct = () => {
        const { showOTP } = this.state;

        this.setState({
            showOTP: !showOTP,
        }, () => {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: false,
                disabled: showOTP
            });
        });
    }

    render() {
        const {
            addressContent,
            charityFoundations,
            immHireCardNameSelector,
            immPdfData,
            maxAmount,
            minAmount,
        } = this.props;
        const { authorization, showOTP } = this.state;
        const messageNGO = buildNotDeductMessageNGO(charityFoundations, false, false, showOTP, this.handleChangeDeduct);
        let showCheckDeduct = messageNGO === true ? true : showOTP;
        const maxAmountValue = maxAmount === LIMIT_CHARITY_AMOUNT ? formatText('ngoAmounts-maxLimit') : maxAmount;
        const operativeName = 'operatives-solidarityCardHire';
        const preContractDocumentInfo = getCardsPreContractPdfData()['solidaria_card'];
        const errorContent = immPdfData.get('errorContent');

        const consentsElement = this.buildConsents();
        const operationParams  = [
            {
                serviceCode: SOLIDARIA_CARD
            },{
                serviceCode: CHARITY_CARD_HIRE
            }, {
                serviceCode: ADD_NEW_SHIPPING_ADDRESS
            }
        ];

        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if (!errorContent) {
            agreementCheckboxContent = (
                <WebappRender>
                    <OKCheckbox
                        extraClass="stocks-contract-tac"
                        idName="tac"
                        onChange={this.handleOnChange}
                        label={this.buildLegalConsentLabel()}
                        errorState={this.state.disclaimerErrorState}
                        errorMessage={<FormattedText
                            value="hireCardOpenDebit-step3CheckboxErrorMsg"
                        />}
                    />
                </WebappRender>
            )
        }

        if (showCheckDeduct && authorization && agreementCheckboxContent) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={HIRE_CHARITY_NO_GDPR}
                    multiOTPGDPRMessageCode={HIRE_CHARITY_GDPR}
                />
            )
        }

        const wizardTitleClassName = contactCenterClassName('print-title', 'contract-view__wizard__title')
        const summaryTitleClassName = contactCenterClassName('print-paragraph', 'hire-confirmation__summary-title')
        return (
            <Fragment>
                <div id="printable-wizard">
                    <FormattedText
                        className={wizardTitleClassName}
                        value="accountInterveners-securityConfirmation"
                    />
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={formatText(operativeName)}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <h4 className="step__subtitle">
                        <FormattedText
                            value="hireSolidarityCard-confirmationStepSubtitle"
                            className="hire-confirmation__summary-title"
                        />
                    </h4>
                    <div className="row" style={{ marginBottom: '40px' }}>
                        <div className="col-xs-4">
                            <FormattedText
                                className="hire-confirmation__summary-title"
                                value="hireSolidarityCard-selectedName"
                            />
                            <p>{immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}</p>
                            <FormattedText
                                value="hireSolidarityCard-selectedNGOMainBodySummaryMessage"
                                className={summaryTitleClassName}
                            />
                            {
                                charityFoundations.map((charityFoundation, index) => {
                                    return (
                                        <div key={index}>{charityFoundation.getIn(['suggestion', 'name'])}</div>
                                    )
                                })
                            }
                        </div>
                        <div className="col-xs-3">
                            <div className="hire-confirmation__limit-value">
                                <FormattedText
                                    value="common-minimumLimit"
                                    className="hire-confirmation__summary-title"
                                />:
                                <div>{`${minAmount} €/`}<FormattedText
                                    value="common-month"
                                    format="lowercase"
                                /></div>
                            </div>
                            <div className="hire-confirmation__limit-value">
                                <FormattedText
                                    value="common-maximumLimit"
                                    className="hire-confirmation__summary-title"
                                />:
                                <div>
                                    {maxAmount === LIMIT_CHARITY_AMOUNT ? maxAmountValue : `${maxAmount}€/`}
                                    {maxAmount !== LIMIT_CHARITY_AMOUNT && <FormattedText
                                        value="common-month"
                                        format="lowercase"
                                    />}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-5">
                            <FormattedText
                                value="hireCardSidebar-shippingAddress"
                                className="hire-confirmation__summary-title"
                            />
                            <div>{addressContent}</div>
                        </div>
                    </div>
                    <hr />
                    {consentsElement}
                    <WebappRender>
                        <div className="hire-confirmation__pdf-viewer-container">
                            <PreContractualDocumentViewer
                                preContractDocumentInfo={preContractDocumentInfo}
                                titleKey="preContractDocument_pdfTitlePrecontractual"
                            />
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    {messageNGO}
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </div>
            </Fragment>
        );
    }
}

HireConfirmation.propTypes = {
    addressContent: PropTypes.string.isRequired,
    charityFoundations: PropTypes.array.isRequired,
    hasShippingAddress: PropTypes.bool.isRequired,
    immConsents: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    link: PropTypes.string,
    localOkConsentsActions: PropTypes.func.isRequired,
    localSetWizardButtonStateByButton: PropTypes.func,
    maxAmount: PropTypes.number.isRequired,
    minAmount: PropTypes.number.isRequired,
    onSetAsCurrentStep: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func,
    signaturePass: PropTypes.object,
    setTermsAndCondsText: PropTypes.func,
    processDetail: PropTypes.string,
}

export const HireConfirmationC = connect(
    state => ({
        charityFoundations: state.okWizard.getIn(['steps', 1, 'charityFoundations']),
        minAmount: state.okWizard.getIn(['steps', 1, 'minAmount']),
        maxAmount: state.okWizard.getIn(['steps', 1, 'maxAmount']),
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCardNameSelector: state.hireCardNameSelector,
        immPrinter: state.printer,
        immProfile: state.profile,
        immPdfData: state.precontractualsMergePdfs,
        signaturePass: state.signaturePattern
    }),
    {
        localSetWizardButtonStateByButton: setWizardButtonStateByButton
    }
)(HireConfirmation);
